export * from '@primeuix/themes/nora/panel';
export { default } from '@primeuix/themes/nora/panel';
